module.exports = __webpack_public_path__ + "36acc606557b7a87a1db3dc71a97e40e.pdf";